var motherBoard = "https://shopfront-cdn.tekoapis.com/static/7bf562748dccb296.svg";

export { motherBoard as default };
